/**
 * 在此文件配置系统菜单
 * 注意两点：
 *  要求组件文件目录路径跟菜单的path字段保持一致
 *  路由的数据从这个文件读取
 * 此外：
 *  后续如需要添加菜单权限配置或快速导航菜单，也可以从此文件读取数据，code字段为预留权限码字段
 */
import { handleTreeNode, filterTree } from '_u/tree';

// 路由权限（权限码为path）
const route = (title, path, children, option) => {
  let ret = { title, path }

  // 没有children，但需要传option时，第三个参数就是option
  if (children && !Array.isArray(children)) {
    option = children;
    children = null;
  }

  children && children.length && (ret.children = children);

  ret = Object(ret, option || {});

  return ret;
}

// 按钮权限(权限码为parent.path-code)
const btn = (title, code, option) => {
  let ret = { title, code, isAction: true }
  ret = Object(ret, option || {});
  return ret;
}

let menuList = [
  {
    title: "工作台", path: "operat-platform", code: "",
    children: []
  },
  {
    title: "企业服务", path: "enterprise-serve", code: "",
    children: [
      { title: "服务信息1", path: "serve-information", code: "" },
      { title: "企业服务2", path: "serve-information1", code: "" },
    ]
  },
  {
    title: "组织架构", path: "organization", code: "",
    children: [
      { title: "服务信息", path: "serve-information", code: "" }
    ]
  },
  {
    title: "审批管理", path: "approval-management", code: "",
    children: [
      { title: "服务信息", path: "serve-information", code: "" }
    ]
  },
  {
    title: "计时计费", path: "time-billing", code: "",
    children: [
      { title: "服务信息", path: "serve-information", code: "" }
    ]
  },
  {
    title: "资源编排", path: "resource-arrangement", code: "",
    children: [
      { title: "服务信息", path: "serve-information", code: "" }
    ]
  },
  {
    title: "告警管理", path: "alarm-management", code: "",
    children: [
      { title: "服务信息", path: "serve-information", code: "" }
    ]
  },
  {
    title: "云平台模板管理", path: "cloud-platform", code: "",
    children: [
      { title: "服务信息", path: "serve-information", code: "" }
    ]
  },
]

let menuListTest = [
  route('工作台', 'operat-platform'),
  route('企业服务', 'enterprise-serve', [
    route('服务信息', 'serve-information'),
  ]),
  route('分中心管理', 'subcenter-management', [
    route('分中心信息', 'subcenter-message'),
  ]),
  route('组织架构', 'organization', [
    route('组织管理', 'organization-management'),
  ]),
  // route('审批管理', 'approval-management',  [
  //   route('审批信息', 'approval-information'),
  //   route('审批流管理', 'process-management'),
  // ]),
  // route('计时计费', 'time-billing', [
  //   route('消费统计', 'consumption-statistics'),
  //   route('计费设置', 'billing-settings'),
  // ]),
  // route('资源编排', 'resource-arrangement',[
  //   route('资源与分区', 'resources-zoning'),
  //   route('资源配额', 'resource-quota'),
  // ]),
  // route('告警管理', 'alarm-management',[
  //   route('告警规则', 'resources-zoning'),
  //   route('告警信息', 'resource-quota'),
  // ]),
  // route('云平台模板管理', 'cloud-platform',[
  //   route('平台菜单管理', 'resources-zoning'),
  //   route('平台页面管理', 'resource-quota'),
  // ]),
]
let getMenu = (codeList) => {
  let allCodeList = []; // 总的权限列表（权限码根据）

  const getCode = (code) => {
    let temp = code.split('-');
    if (temp.length > 2) {
      code = `${temp[0]}-${temp[1]}`
    }

    if (allCodeList.includes(code)) {
      return getCode(code + '+');
    } else {
      return code;
    }


  }
  handleTreeNode(menuListTest, (node, parent) => {
    let { path, code } = node;

    // build code
    if (path) {
      node.code = getCode(path);
      allCodeList.push(getCode(path))
    } else if (code) {
      node.code = `${parent.code}-${code}`;
      allCodeList.push(`${parent.code}-${code}`)
    }
  });

  if (Array.isArray(codeList)) {
    return filterTree(menuListTest, node => {
      return codeList.includes(node.code);
    })
  } else {
    return menuListTest;
  }
}
// let menuTest = getMenu();
// console.log(menuTest, 'menuListTest')

export default getMenu